export enum HomeSlidersEnumID {
  verifyEmail = 'verifyEmail',
  verifyID = 'verifyID',
  inviteFriend = 'inviteFriend',
  addPhoneNumber = 'addPhoneNumber',
  cashback = 'cashback',
}

export interface HomeSlider {
  id: HomeSlidersEnumID
  title: string
  titleFontSize?: number
  description: string
  descriptionFontSize?: number
  backgroundImage: string
  internalImage: string
  descriptionIconName?: string
  maxContentWidth?: number
}

export const homeSliders: HomeSlider[] = [
  {
    id: HomeSlidersEnumID.verifyEmail,
    title: 'banners:verifyEmail.title',
    description: 'banners:verifyEmail.description',
    descriptionFontSize: 14,
    backgroundImage: '/assets/images/homeBanners/check-your-email-banner.png',
    internalImage: '/assets/images/homeBanners/email-spiral-3d.png',
    maxContentWidth: 160,
  },
  {
    id: HomeSlidersEnumID.addPhoneNumber,
    title: 'banners:addPhone.title',
    description: 'banners:addPhone.description',
    descriptionFontSize: 14,
    backgroundImage: '/assets/images/homeBanners/phone-banner.png',
    internalImage: '/assets/images/big-phone.png',
    maxContentWidth: 190,
  },
  {
    id: HomeSlidersEnumID.verifyID,
    title: 'banners:verifyID.title',
    description: 'banners:verifyID.description',
    descriptionFontSize: 14,
    backgroundImage: '/assets/images/homeBanners/check-your-id-banner.png',
    internalImage: '/assets/images/homeBanners/mail-box.png',
    maxContentWidth: 180,
  },
  {
    id: HomeSlidersEnumID.inviteFriend,
    title: 'banners:inviteFriends.title',
    titleFontSize: 18,
    description: 'banners:inviteFriends.description',
    backgroundImage: '/assets/images/homeBanners/invite-friends-banner-bg.png',
    internalImage: '',
    descriptionIconName: 'clock',
    maxContentWidth: 180,
  },
  {
    id: HomeSlidersEnumID.cashback,
    title: 'banners:communityCashback.title',
    description: 'banners:communityCashback.description',
    backgroundImage: '/assets/images/homeBanners/cashback-banner.png',
    internalImage: '/assets/images/homeBanners/cashback-banner-internal.png',
    maxContentWidth: 160,
  },
]
